export const CALL_HUB_METHODS = {
  registerParticipant: "RegisterParticipant",
  registerReceiver: "RegisterReceiver",
  startCall: "StartCall",
  openIncomingCall: "OpenIncomingCall",
  acceptCall: "AcceptCall",
  acceptCallWaiting: "AcceptCallWaiting",
  swapActiveCall: "SwapActiveCall",
  transferCall: "TransferCall",
  declineCall: "DeclineCall",
  endCall: "EndCall",
  sendCallSignal: "SendCallSignal",
  getIceServers: "GetIceServers",
};

export const CALL_HUB_EVENTS = {
  participantRegistered: "ParticipantRegistered",
  receiverRegistered: "ReceiverRegistered",
  callStarted: "CallStarted",
  incomingCall: "IncomingCall",
  callAccepted: "CallAccepted",
  callQueued: "CallQueued",
  callWaiting: "CallWaiting",
  queueUpdated: "QueueUpdated",
  callTransferring: "CallTransferring",
  callTransferred: "CallTransferred",
  callSignal: "CallSignal",
  callDeclined: "CallDeclined",
  callEnded: "CallEnded",
  callUnavailable: "CallUnavailable",
  callBusy: "CallBusy",
  callError: "CallError",
};
